<template>
  <div class="share-card">
    <div class="share-header">
      <div class="share-icon">
        <i class="el-icon-share"></i>
        <span>Shared Stack</span>
        <span class="dot">•</span>
        <span class="author-wrapper">
          <span class="author-label">by</span>
          <el-avatar :size="16" class="author-avatar" style="font-size: 10px;">{{ share.post.author?.charAt(0) || 'U' }}</el-avatar>
          <span class="author-name">{{ share.post.author }}</span>
        </span>
        <span class="dot">•</span>
        <span class="timestamp">{{ formattedTimestamp }}</span>
      </div>
      <div class="share-actions">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="viewPost"
          class="view-btn"
        >
          View the Stack
        </el-button>
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="text" size="mini" class="more-btn">
            <i class="el-icon-more"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="remove">
              <i class="el-icon-delete"></i> Remove
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    
    <div class="share-content">
      <div class="post-preview">
        <div class="post-header">
          <h3 class="post-title" @click="viewPost">{{ share.post.title }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareCard',
  props: {
    share: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTimestamp() {
      const date = new Date(this.share.timestamp)
      const now = new Date()
      const diffInHours = Math.floor((now - date) / (1000 * 60 * 60))
      
      if (diffInHours < 1) {
        return 'Just now'
      } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      } else {
        const diffInDays = Math.floor(diffInHours / 24)
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
      }
    }
  },
  methods: {
    viewPost() {
      // Navigate to post detail page using query params
      this.$router.push({
        path: '/stack',
        query: {
          id: this.share.post.id
        }
      })
    },
    handleCommand(command) {
      if (command === 'remove') {
        this.$emit('remove', this.share.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.share-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #1159AF;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #dee2e6;
  }
}

.share-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.share-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #1159AF;
  }

  > span {
    font-weight: 600;
    color: #1159AF;
    font-size: 14px;
  }

  .dot {
    color: #adb5bd;
    font-size: 14px;
    font-weight: normal;
  }

  .author-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;

    .author-label {
      font-size: 12px;
    }

    .author-avatar {
      flex-shrink: 0;
    }

    .author-name {
      font-size: 12px;
    }
  }

  .timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;
  }
}

.share-actions {
  display: flex;
  gap: 8px;
  
  .view-btn {
    color: #1159AF;
    font-size: 12px;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .remove-btn {
    color: #6c757d;
    font-size: 12px;
    
    &:hover {
      color: #dc3545;
    }
  }
}

.share-content {
  .post-preview {
    .post-header {
      margin-bottom: 12px;
      
      .post-title {
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
        margin: 0 0 6px 0;
        cursor: pointer;
        line-height: 1.3;
        word-wrap: normal;
        word-break: normal;
        overflow-wrap: normal;
        hyphens: none;
        
        &:hover {
          color: #1159AF;
        }
      }
      
      .post-meta {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #6c757d;
        
        .dot {
          color: #adb5bd;
        }
      }
    }
    
    .post-excerpt {
      margin-bottom: 12px;
      
      p {
        font-size: 14px;
        color: #495057;
        margin: 0;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    
    .post-stats {
      display: flex;
      gap: 16px;
      
      .stat-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        color: #6c757d;
        
        i {
          font-size: 14px;
          color: #27ae60;
        }
      }
    }
  }
}
</style> 